import type { ComponentProps } from "react";
import { useTranslation } from "../../i18n";
import { cn } from "../../lib/utils";

export function Pagination({ className, ...props }: ComponentProps<"nav">) {
  const { t } = useTranslation();
  return <nav aria-label={t("common.pagination")} data-slot="pagination" className={cn("flex w-full items-center justify-between gap-3", className)} {...props} />;
}

export function PaginationContent({ className, ...props }: ComponentProps<"ul">) {
  return <ul data-slot="pagination-content" className={cn("m-0 flex list-none items-center gap-2 p-0", className)} {...props} />;
}

export function PaginationItem(props: ComponentProps<"li">) {
  return <li data-slot="pagination-item" {...props} />;
}
